import React from 'react';
import { FormattedMessage } from 'react-intl';

export const areMaximumColumnsPinned = (columnConfiguration, maxPinnableColumns) => {
  const amountPinned = columnConfiguration.reduce((numberPinned, column) => (column.pinned ? numberPinned + 1 : numberPinned), 0);
  return amountPinned === maxPinnableColumns;
};

export const findLargestGridIndexPinnedId = (columnConfiguration) => {
  const largestIndexPinnedColumn = columnConfiguration
    .filter((column) => column.pinned)
    .reduce(
      (largestIndexColumn, column) => {
        return column.index > largestIndexColumn.index ? column : largestIndexColumn;
      },
      { index: -1 },
    );

  return largestIndexPinnedColumn.id;
};

export const getColumnDisplayName = (baseColumn) => {
  const { getMessageDescriptor } = baseColumn;
  if (getMessageDescriptor) {
    return <FormattedMessage {...getMessageDescriptor()} />;
  }
};

export const findLargestGridIndexPinnedName = (columnConfiguration, baseColumns) => {
  const largestGridIndexPinnedId = findLargestGridIndexPinnedId(columnConfiguration);
  if (!largestGridIndexPinnedId) {
    return;
  }
  const matchingBaseColumn = baseColumns.find((baseColumn) => baseColumn.id === largestGridIndexPinnedId);
  return matchingBaseColumn ? getColumnDisplayName(matchingBaseColumn) : undefined;
};
